<template>
    <div class="card tyre featured-top-spot border-0 mb-3" :data-tyre-element="tyre.st_code">
        <div class="card-body rounded border-light-subtle border text-start p-3">
            <div class="row">
                <div class="d-none d-sm-block col-sm-3 text-center">
                    <div class="tyre-image">
                        <a :href="tyre?.tyre_info_url">
                            <img :src="tyre?.image_url" class="img-fluid" :alt="tyre.brand + ' ' + tyre.tyre_range + ' logo'" height="135" @error="replaceByDefault"/>
                        </a>
                    </div>
                </div>
                <div class="col-12 col-sm-9 col-md-4 col-xl-5 my-3 my-md-0">
                    <div class="d-flex align-items-center mb-2">
                        <img
                            :src="tyre.brand_image_url"
                            class="brand-image"
                            :alt="tyre.brand + ' logo'"
                            height="40"
                            @error="replaceBrandByDefault"
                        />
                        <fitments v-if="tyre.fitments?.length > 0" class="position-relative mx-2" style="height: 30px;" :fitments="tyre.fitments"></fitments>
                        <awards-new class="ms-2" v-if="tyre.award_badges" :awards="tyre.award_badges" :tyre-url="tyre.tyre_info_url"></awards-new>
                    </div>
                    <div v-if="tyre.range_slug == 'uv1b' && isUber" class="text-center text-black p-2 my-3 rounded-32" style="background: rgb(238, 210, 103);">
                        <b class="d-block d-sm-inline-block me-sm-2">50% off ENSO tyres for Uber drivers -</b>
                        <br class="d-none d-lg-block"/><span>Applied automatically at checkout</span>
                    </div>
                    <p class="mb-0" v-html="tyre.featured_content.text"></p>
                    <div class="tyre-image mobile d-block d-sm-none">
                        <a :href="tyre?.tyre_info_url">
                            <img :src="tyre?.image_url" class="img-fluid d-block mx-auto" :alt="tyre.brand + ' ' + tyre.tyre_range + ' logo'" height="135" @error="replaceByDefault"/>
                        </a>
                    </div>
                </div>
                <div class="col-12 col-md-5 col-xl-4">
                    <div class="row">
                        <div class="col-12 col-sm-6 col-md-12">
                            <p class="mb-0 text-lg">{{ tyre.tyre_range }}</p>
                            <p class="mb-0">{{ tyre.size }} {{ tyre.load_speed }}</p>
                            <div class="d-block d-lg-flex">
                                <specialisms class="me-3" :tyre="tyre"></specialisms>
                                <rating-labels :fuel="tyre.fuel" :wet="tyre.wet" :decibels="tyre.decibels" :noise-rating="tyre.noise_rating"></rating-labels>
                            </div>
                            <div class="my-2">
                                <reviews
                                    :identifier="`${tyre.brand_slug}-${tyre.range_slug}`"
                                ></reviews>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-12">
                            <div class="d-flex align-items-center justify-content-between gap-3 gap-sm-0">
                                <b class="price">&pound;{{ tyre.display_price }}</b>
                                <p class="mb-0 d-flex">{{ homeDelivery ? 'Mail order' : 'Fully fitted' }} price
                                    <route-tooltip
                                        :home-delivery="homeDelivery"
                                        class="ms-2"
                                    ></route-tooltip>
                                </p>
                            </div>
                            <earliest-fitting
                                v-if="this.$parent.$parent.updatedPostcode && this.$parent.$parent.homeDelivery == false"
                                :fitting-today="tyre.fitting_today"
                                :fitting-tomorrow="tyre.fitting_tomorrow"
                                :earliest-fitting-date="tyre.earliest_fitting_date"
                                :postcode="postcode"
                            ></earliest-fitting>
                            <div class="d-block d-md-flex flex-md-column">
                                <select name="quantity" id="quantity" class="form-control mb-2 cursor-pointer" v-model="quantity">
                                    <option v-for="index in 5" :key="index" :value="index">{{ index }}</option>
                                </select>
                                <button class="btn w-100" :class="newButtonColour" @click="trackAndAdd()">
                                    {{ newButtonText }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import tyre from '@shared/mixins/tyre';

    export default {
        props: ['tyre', 'basket', 'postcode', 'homeDelivery', 'isUber'],
        mixins: [tyre],
        data() {
            return {
                quantity: this.$parent.$parent.quantity,
                featuredTopSpotFlag: true
            }
        },
        mounted() {
        },
        methods: {
            trackAndAdd() {
                //Track Featured Top Spot Added To Basket
                if(typeof(this.$gtag) !== 'undefined') {
                    this.$gtag.event('featured_top_spot', {
                        'event_category' : 'FeaturedTopSpot',
                        'event_label' : 'Added'
                    });
                }
                else {
                    console.log('gtag not loaded');
                }
                
                this.$parent.$parent.addTyreToBasket(this.tyre.st_code, this.quantity)
            }
        },
        computed: {
            //mirroring tyreText and buttonColour computed vars from mixin.
            newButtonText() {
                return this.inBasket ? 'In Basket' : 'Buy now';
            },
            newButtonColour() {
                return this.inBasket ? 'btn-secondary' : 'btn-primary';
            }
        }
    }
</script>

<style lang="scss" scoped>
    .featured-top-spot {
        .card-body {
            position: relative;
            .price {
                font-size: 22px;
            }
            .per {
                font-size: 14px;
            }
            .tyre-info-badge {
                position: absolute;
                bottom: 5px;
                left: -5px;
                text-align: left;
            }
            .tyre-image {
                &.mobile {
                    height: 150px;
                    overflow: hidden;
                }
                &:not(.mobile) {
                    img {
                        max-height: 300px;
                        margin: 0 auto;
                        display: block;
                    }
                }
            }
        }
    }
</style>
